import request from "@/utils/request";
import qs from "qs";

/**
 * 代理公司下的客户列表
 * @param query
 */
export function fetchList(companyId, query) {
  return request({
    url: "/api/customer/list/" + companyId,
    method: "post",
    data: query
  });
}

/**
 * 查询全部客户
 * @param query
 */
export function findAll() {
  return request({
    url: "/api/customer/all",
    method: "get"
  });
}

/**
 * 保存客户
 * @param param
 */
export function save(param) {
  return request({
    url: "/api/customer/save",
    method: "post",
    data: param
  });
}

/**
 * 修改客户
 * @param param
 */
export function update(param) {
  return request({
    url: "/api/customer/update",
    method: "post",
    data: param
  });
}

/**
 * 删除客户
 * @param param
 */
export function remove(param) {
  return request({
    url: "/api/customer/delete/" + param,
    method: "post"
  });
}

/**
 * 客户详情
 * @param param
 */
export function get(id) {
  return request({
    url: `/api/customer/get/${id}`,
    method: "post"
  });
}
